/**
 * 历史定位一览组件
 * 创建时间：2017-02-22
 * 修改人：baixx
 * 修改时间：2017-03-31
 */
<template>
<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
	<div class="ibox float-e-margins ibox-content">
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label ">设备ID</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.displayDeviceid">
				</div>
				<label class="col-sm-1 control-label focus_color">*设备编号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.deviceNum" >
				</div>
				<label class="col-sm-1 control-label focus_color">*设备类型</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="deviceInfo.obdFlag">
				</div>
			</div>

			<div class="form-group mb0px">
				<label class="col-sm-1 control-label">开始时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.startTime" class="form-control" ref="dateFrom" :options="localeOption"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">结束时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.endTime" class="form-control" ref="dateTo" :options="localeOption"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
		    </div>
		    <div class="form-group mb0px">
				<div class="col-sm-12 text-right" v-if="levv==1" key="user-didi">
		    		<button v-if="permissionD.indexOf('fileCarList_historyPositionReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
				    <button v-if="permissionD.indexOf('fileCarList_historyPositionSelect') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
				</div>
		    	<div class="col-sm-12 text-right" v-else key="user-rb">
		    		<button v-if="permission.indexOf('carFileList_historyPositionReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
				    <button v-if="permission.indexOf('carFileList_historyPositionSelect') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
				</div>
		    </div>
	    </div>
    </div>
    <table class="table mb0px table-striped table-bordered">
		<thead>
			<tr>
				<th v-for="(thead, index) in theadList" :key="'theadlist' + index">{{thead}}</th>
				<th></th>
			</tr>
		</thead>
		<transition-group name="list-complete" tag="tbody">
			<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="'fileInfo' + index">
				<td>{{fileInfo.gpsTime}}</td>
				<td>{{fileInfo.createTime}}</td>
				<td>{{fileInfo.latLng}}</td>
				<td>{{fileInfo.address}}</td>
				<td>{{fileInfo.status}}</td>
				<td>{{fileInfo.directionName}}</td>
				<td>{{fileInfo.speed}}</td>
				<td class="text-center" v-if="levv==1" key="user-didi">
					<a v-if="permissionD.indexOf('fileCarList_historyPositionSelectPoint') == -1" @click="gotoPosition(fileInfo.latLng,fileInfo.gpsTime)">查定位点&nbsp;</a>
					<a v-if="permissionD.indexOf('fileCarList_historyPositionSelectTrace') == -1" @click="gotoTrace(fileInfo.gpsTime)">&nbsp;当天轨迹</a>
				</td>
				<td class="text-center" v-else key="user-rb">
					<a v-if="permission.indexOf('carFileList_historyPositionSelectPoint') == -1" @click="gotoPosition(fileInfo.latLng,fileInfo.gpsTime)">查定位点&nbsp;</a>
					<a v-if="permission.indexOf('carFileList_historyPositionSelectTrace') == -1" @click="gotoTrace(fileInfo.gpsTime)">&nbsp;当天轨迹</a>
				</td>
			</tr>
		</transition-group>
	</table>
	<!--分页组件开始-->
	<pagination v-if="fileInfoList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
	<!--分页组件结束-->
</div>
</template>
<script>
    import Pagination from 'components/common/Pagination'
    import Datepicker from 'components/common/datepicker/Datepicker'
    import { zh } from 'flatpickr/dist/l10n/zh'
import {goTabMixin} from 'util/util'
export default{
  name: 'HistoryPosition',
  mixins: [goTabMixin],
  components: {
        Pagination,
        Datepicker
  },
  data () {
        return {
          permission: this.$store.state.permission.permission['carFileList'] ? this.$store.state.permission.permission['carFileList'] : [],
          permissionD: this.$store.state.permission.permission['fileCarList'] ? this.$store.state.permission.permission['fileCarList'] : [],
          loadingstatus: false,
          localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true
			    },
          deviceInfo: {
            displayDeviceid: 'VD' + this.$parent.deviceInfo.deviceid,
            deviceid: this.$parent.deviceInfo.deviceid,
            deviceNum: this.$parent.deviceInfo.deviceNum,
            obdFlag: this.$parent.deviceInfo.obdFlag
          },
				// 以下为查询属性
          queryParam: {
            startTime: '',
			    	endTime: '',
			    	page_index: 1
          },
          theadList: ['定位时间', '服务器时间', '定位经纬度', '定位地址', '车辆状态', '方向', '时速', ''],
          fileInfoList: [],
			    pageInfo: {},
			    pageNo: 1
        }
  },
  beforeMount () {
        this.getPosInfo()
  },
  computed: {
        levv () {
          return this.$store.state.user.levv
        },
		   //	起止时间是否合法
        validDates: function () {
          if (this.queryParam.startTime && this.queryParam.endTime && this.queryParam.startTime > this.queryParam.endTime) {
            return false
          } else {
            return true
          }
        }
  },
  methods: {
			// 查询方法
        searchInfo () {
          this.queryParam.page_index = 1
          this.getPosInfo()
        },
			// 查询历史定位信息
        getPosInfo () {
          this.loadingstatus = true
          this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/' + this.$parent.queryparam.vehicleid + '/devices/' + this.$parent.queryparam.deviceid + '/positions', {params: this.queryParam})
				.then(res => {
  if (res.body.success) {
        const resInfo = res.body.data
        const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
        this.pageInfo = {
          pageNum: pageNum,
          pages: pages,
          total: total,
          isFirstPage: isFirstPage,
          isLastPage: isLastPage
        }
        this.fileInfoList = resInfo.list
  } else {
        this.$parent.openModal(res.body.message)
  }
  this.loadingstatus = false
}, res => {
  this.$parent.openModal(res.body.message)
  this.loadingstatus = false
}).catch(res => {
  this.$parent.openModal(OPERATE_EXCEPTION)
  this.loadingstatus = false
})
        },
			// 从分页组件获取页码参数
        getPageNo (pageNo) {
          this.pageNo = pageNo
          this.queryParam.page_index = pageNo
          this.getPosInfo()
        },
        resetQueryParams: function () {
          this.$refs.dateFrom.handleClear()
          this.$refs.dateTo.handleClear()
          this.queryParam = {
            startTime: '',
			    	endTime: ''
          }
        },
			// 跳转定位
        gotoPosition (latLng, time) {
				// 1,切换到轨迹回放tab
          this.addTab()
				// 2,追加到轨迹队列
          const param = {
            deviceId: this.deviceInfo.deviceid,
            gpsTime: this.getDateFormat(time),
            lat: latLng.split(',')[0],
            lng: latLng.split(',')[1],
            vehicleId: this.$parent.queryparam.vehicleid
          }
          this.$store.dispatch('addLocatePoint', param)
        },
			// 跳转轨迹
        gotoTrace (time) {
				// 1,切换到轨迹回放tab
          this.addTab()
				// 2,追加到轨迹队列
          let arr = []
          arr.push(this.$parent.queryparam.vehicleid)
          const param = {
            deviceId: this.deviceInfo.deviceid,
            vehicleIds: arr,
            gpsTime: this.getDateFormat(time),
            type: 3
          }
          this.$store.dispatch('addTrackHistory', param)
        },
			// 跳转到轨迹回放标签
        addTab () {
          this.openDidiVehicleTrace()
				// const obj = {
				// 	name:'车辆轨迹回放',
				// 	code:'vehicleTrace',
				// 	id:'PageVehicleTrace',
				// 	route:'/indexhome/vehicleTrace',
				// 	No:'vehicleTrace'
				// }
				// this.$router.push(obj.route);
				// this.$store.dispatch('addTab',obj);
        },
			// getDateFormat
        getDateFormat (str) {
          let str1 = str.split(' ')[0]
          let str2 = str.split(' ')[1]
          let str11 = str1.split('-').join('')
          let str22 = str2.split(':').join('')
          return str11 + str22
        }
  }
}
</script>



// WEBPACK FOOTER //
// HistoryPosition.vue?de405cf0